import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  border: 1px solid #848ec3;
  background: #f8f8ff;
  color: #0b0b0c;
  border-radius: 8px;
  padding: 16px;
  width: 50%;
  min-height: 120px;
  display: flex;
  align-items: center;
  display: flex;
  width: 100%;
  gap: 1rem;
`;

const InvitedSection = styled.div`
  flex: 1 1 auto;
  text-align: left;

  h5 {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 8px;
    word-break: break-word;
    line-height: 1.2;
  }
`;

const UninvitedSection = styled(InvitedSection)``;

const StatisticsItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  flex-wrap: wrap;
  gap: 4px;
`;

const StatisticsItemLabel = styled.span`
  font-weight: normal;
  white-space: nowrap;
  flex-shrink: 0;
`;

const StatisticsItemValue = styled.span`
  font-weight: bold;
  text-align: right;
  flex: 1;
`;

const AttendanceStatistics = ({ attendanceStats, totalRows }) => {
  return (
    <Wrapper>
      <InvitedSection>
        <h5>{"INVITED"}</h5>
        <StatisticsItem>
          <StatisticsItemLabel>{"Attended"}</StatisticsItemLabel>
          <StatisticsItemValue>
            {`${attendanceStats.invitedAttended} of ${totalRows}`}
          </StatisticsItemValue>
        </StatisticsItem>
        <StatisticsItem>
          <StatisticsItemLabel>{"Proxy"}</StatisticsItemLabel>
          <StatisticsItemValue>
            {attendanceStats.invitedAttendedByProxy}
          </StatisticsItemValue>
        </StatisticsItem>
      </InvitedSection>
      <UninvitedSection>
        <h5>{"UNINVITED"}</h5>
        <StatisticsItem>
          <StatisticsItemLabel>{"Attended"}</StatisticsItemLabel>
          <StatisticsItemValue>
            {attendanceStats.notInvitedAttended}
          </StatisticsItemValue>
        </StatisticsItem>
        <StatisticsItem>
          <StatisticsItemLabel>{"Proxy"}</StatisticsItemLabel>
          <StatisticsItemValue>
            {attendanceStats.notInvitedAttendedByProxy}
          </StatisticsItemValue>
        </StatisticsItem>
      </UninvitedSection>
    </Wrapper>
  );
};

export default AttendanceStatistics;
